import e from "dayjs";
// src/design/forms/datepicker/calendar-engine/use-cases/english_date/is_today.ts
var t = (t) => {
	let n = e();
	return e(t).isSame(n, "day");
};
export { t as is_today };

//# sourceMappingURL=is_today.js.map